module.exports = __webpack_public_path__ + "static/media/oahu.ff2061cd.bin";